// extracted by mini-css-extract-plugin
export default {"AttachmentPreview":"vlUoXc2Kfy6EPiXFk8lc"};